import * as React from "react";
import { Card, CardContent, Typography, Box } from "@mui/material";
import {
  ChartContainer,
  BarPlot,
  LinePlot,
  ChartsXAxis,
  ChartsYAxis,
  ChartsLegend,
  ChartsTooltip,
} from "@mui/x-charts";

const creators = [
  "Tim",
  "Bex",
  "Joe",
  "Foster",
  "Leon",
  "TapiwaAlpha",
  "Jona",
  "None",
  "Ruwadzano",
  "Trish",
  "Veronica",
  "Jared",
  "Ernest",
  "Maxwell",
];

const venuesContributed = [57, 20, 12, 12, 9, 8, 7, 6, 5, 4, 2, 2, 1, 1];
const avgQuality = [50, 47, 52, 45, 42, 43, 36, 58, 37, 41, 52, 54, 60, 47];

export default function CreatorInsightsWidget() {
  return (
    <Card sx={{ borderRadius: 3, boxShadow: 3, height: "100%" }}>
      <CardContent>
        <Typography variant="h6" fontWeight={600} gutterBottom>
          Creator Insights (Volume vs Quality)
        </Typography>

        <Box sx={{ height: 380 }}>
          <ChartContainer
            xAxis={[
              {
                id: "creators",
                scaleType: "band",
                data: creators,
              },
            ]}
            yAxis={[
              {
                id: "venues",
                label: "Number of Venues",
                position: "left",
              },
              {
                id: "quality",
                label: "Avg Completeness %",
                position: "right", // 👈 move to right
                min: 0,
                max: 100,
              },
            ]}
            series={[
              {
                type: "bar",
                yAxisId: "venues",
                data: venuesContributed,
                label: "Venues Contributed",
              },
              {
                type: "line",
                yAxisId: "quality",
                data: avgQuality,
                label: "Avg Quality %",
                curve: "linear", // 👈 straight line
                color: "#d32f2f",
              },
            ]}
          >
            <BarPlot />
            <LinePlot />
            <ChartsXAxis />
            <ChartsYAxis axisId="venues" />
            <ChartsYAxis axisId="quality" />
            <ChartsLegend />
            <ChartsTooltip />
          </ChartContainer>
        </Box>
      </CardContent>
    </Card>
  );
}
